import { DefaultPage, CreateScheduleTask, UpdateTaskSchedule, TaskDetail } from './';

export default {
  path: 'schedule/:version/v',
  name: 'Schedule',
  childRoutes: [
    { path: ':projectId', name: 'Schedules', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/create',
      name: 'Create schedule task',
      component: CreateScheduleTask,
      isPrivate: true,
    },
    {
      path: ':projectId/update/:taskId',
      name: 'Update task schedule',
      component: UpdateTaskSchedule,
      isPrivate: true,
    },
    {
      path: ':projectId/detail/:taskId',
      name: 'Task detail',
      component: TaskDetail,
      isPrivate: true,
    },
  ],
};
